import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IGetStatusDateChangedInterventionRequestAction {
  data: {
    id: number;
  };
  functions: {
    error: (err: any) => void;
  };
}

function getStatusDateChangedRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IGetStatusDateChangedInterventionRequestAction>,
) {
  draft.getStatusDateChanged.config.isLoading = true;
}

export default getStatusDateChangedRequest;
